import React, { useRef, useState, useEffect } from "react"
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { RowContainer, LabelTitle } from "./LabelTitle"
import { Slider } from "../ui/slider"


// import DiffusionOptionsDescEta from "./DiffusionOptionsDesc/DiffusionOptionsDescEta";
import StyleChangeDescGuidance from "./StyleChangeDesc/StyleChangeDescGuidance";

import { useHookStore } from "../../hook-store/store"
// import { resizeImageFile } from '../../utils/image/image-utils';
import { marks } from '../../utils/marks';

import "./DiffusionOptionsImagePrompt.css";


function StyleChangeGuidance() {
    
    const [t] = useTranslation('translation');
  
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [hStore, hDispatch] = useHookStore();
    const { 
      styleChangeGuidance,
    } = (hStore as any).iopaintStore;

    const [showEtaDesc, setShowEtaDesc] = useState(false);

    const changeStyleChangeGuidanceHandler = (val: any) => {
      if (val >= 2 && val <= 8) {
        (hDispatch as any)('SET_STYLECHANGEGUIDANCE', val);
      }
    }

    return (
      <div 
      // className="flex flex-col gap-1"
      >
        <div>
          <LabelTitle
            htmlFor="style-change-guidance"
            text="Style Change Guidance"
            // toolTip="The number of denoising steps. More denoising steps usually lead to a higher quality image at the expense of slower inference."
            toolTip={`style-change-guidance`}
          />

          <span
            onClick={() => {
              setShowEtaDesc(!showEtaDesc);
            }}
          >
            {' '}{marks.questionCircleOMark}
          </span>
        </div>
        <RowContainer>
          <Slider
            className="w-[180px]"
            // defaultValue={[30]}
            defaultValue={[styleChangeGuidance]}
            min={2}
            // max={100}
            // max={4}
            max={8}
            step={0.5}
            value={[styleChangeGuidance]}
            onValueChange={(vals) => { 
              changeStyleChangeGuidanceHandler(vals[0]);
              // updateSettings({ eta: vals[0] })
            }}
          />
          {/* <NumberInput
            id="eta"
            className="w-[60px] rounded-full"
            numberValue={inputEta}
            allowFloat={true}
            onNumberValueChange={(val) => {
              changeEtaHandler(val);
              // updateSettings({ eta: val })
            }}
          /> */}
          <div>{styleChangeGuidance}</div>
        </RowContainer>

        {showEtaDesc && (
          <StyleChangeDescGuidance />
        )}
      </div>
    )
  }


export default StyleChangeGuidance